import predicates from '../predicates'
import selectors from '../selectors'
import { SHARE_TRAFFIC_SOURCE } from '../constants'

const share = {
  rule: predicates.and(
    predicates.searchParamIncludesOne('utm_medium', 'share'),
    predicates.searchParamsIncludeOne('utm_source')
  ),
  extractor: traffic => {
    const trafficSource = SHARE_TRAFFIC_SOURCE
    const trafficId = selectors.searchParamValue(traffic, 'utm_source')

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default share



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/share.js